import { DEFAULT_CURRENCY_CODE } from '@angular/core';

export function provideCurrencyPipe() {
  return {
    provide: DEFAULT_CURRENCY_CODE,
    useFactory: DwCurrencyPipeFactory,
  };
}

export function DwCurrencyPipeFactory() {
  return 'EUR';
}
